import sharp from 'sharp';

export interface CompressedImage {
  buffer: Buffer;
  sizeBytes: number;
}

const COMPRESSIBLE_MIME_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp']);

export function isCompressible(mimeType: string): boolean {
  return COMPRESSIBLE_MIME_TYPES.has(mimeType);
}

// compressionPercent is "how much smaller", not encoder quality — 80%
// compression means a low-quality, heavily-compressed encode. Mapped
// directly to encoder quality (quality = 100 - compressionPercent), the
// same one-pass model every mainstream image tool uses: output size varies
// with image content, it isn't an exact target ratio.
export async function compressImage(
  buffer: Buffer,
  mimeType: string,
  compressionPercent: number
): Promise<CompressedImage> {
  const quality = Math.max(1, Math.min(100, 100 - compressionPercent));
  const image = sharp(buffer);

  const encoded = await (mimeType === 'image/png'
    ? image.png({ quality })
    : mimeType === 'image/webp'
      ? image.webp({ quality })
      : image.jpeg({ quality })
  ).toBuffer();

  return { buffer: encoded, sizeBytes: encoded.length };
}
